<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item>
        <i class="iconfont icon_home icon-t-1"></i>
        <span>资料管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>常用货物类型</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-panel">
      <div class="toolbar-item" id="auto-0">
        <span class="item-label">类型名称</span>
        <el-input
          v-model.trim="filter.keyword"
          style="width: 450px"
          :maxlength="ordernumberKeywordLimit"
          placeholder="请输入类型名称"
        >
        </el-input>
      </div>
      <div class="toolbar-item">
        <el-button type="primary" size="small" @click="search" id="auto-1">搜索</el-button>
        <el-button size="small" @click="resetSearch" id="auto-2">重置</el-button>
      </div>
    </div>

    <div class="table-custom-box mt-10" id="auto-4">
      <div class="table-header">
        <div class="table-header-title">常用货物类型</div>
        <el-button type="primary" size="small" @click="add" id="auto-3">添加常用类型</el-button>
      </div>
      <el-table :data="tableData.data" border>
        <el-table-column type="index" label="序号" width="50"> </el-table-column>
        <el-table-column prop="showDetail" label="货物类型" min-width="90"> </el-table-column>
        <el-table-column label="操作" min-width="70" align="center">
          <template v-slot="scope">
            <el-button type="text" class="font-size12 font-red" @click="handleDel(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <stock-kind ref="stockKind" width="220px" @callback="selectStockKind"></stock-kind>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:4
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import axios from '@/api/axiosNew';
import api from '@/api/settings.new.api';
import { commonEventTracking } from '@/utils';
import StockKind from '@/components/StockKind.vue';
export default {
  components: { StockKind },
  name: 'CargoType',
  data() {
    return {
      filter: { keyword: '' },
      cache: {},
      tableData: {
        data: [],
        total: 0
      }
    };
  },

  created() {
    commonEventTracking('stockKindPage', 'page', 'pltUserBehavior');
    this.search();
  },
  methods: {
    search() {
      this.cache = { ...this.filter };
      this.axiosRequest();
    },
    resetSearch() {
      this.filter.keyword = '';
    },
    axiosRequest() {
      axios.post(api.commonGoodsQry, { ...this.cache }).then(res => {
        this.tableData = res.data;
      });
    },
    add() {
      this.$refs.stockKind.openDia();
    },
    selectStockKind() {
      this.axiosRequest();
    },
    handleDel(row) {
      this.$confirm('是否删除该常用货物类型?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          axios.post(api.commonGoodsDelete, { id: row.id }).then(res => {
            this.axiosRequest();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="postcss">
.table-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 12px 0 12px 0;
  .table-header-title {
    font-size: 18px;
    color: black;
    font-weight: bold;
  }
}
</style>
